import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { APP_CONFIG } from '../core';
import { ConfirmationComponent } from '../shared';
import { VwBaseComponent } from './shared';
import { VwCorrectionComponent } from './vw-correction';
import { VwDeformityComponent } from './vw-deformity';
import { VwNavbarComponent } from './vw-navbar';
import { VwPlanComponent } from './vw-plan';


/**
 * Page component of view plan.
 */
@Component({
	selector: 'view',
	templateUrl: './view.component.html',
	imports: [
		VwPlanComponent,
		VwNavbarComponent,
		VwDeformityComponent,
		VwCorrectionComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class ViewComponent extends VwBaseComponent implements OnInit {

	private readonly config = inject(APP_CONFIG);
	private readonly modalSrv = inject(NgbModal);


	ngOnInit(): void {
		this.srv.init().subscribe({
			error: (err: Error) => this.handlePlanError(err)
		});
	}

	private handlePlanError(err: Error): void {
		switch (err.message) {
			case 'PlanNotFound': {
				this.openInvalidPlanModal(this.labels().PLAN_DELETED_WARNING_MESSAGE);
				break;
			}
			case 'PlanNotValid': {
				this.openInvalidPlanModal(this.labels().INVALID_PLAN_MODAL_MESSAGE);
				break;
			}
			default:
				throw err;
		}
	}

	private openInvalidPlanModal(message: string): void {
		const modalRef = this.modalSrv.open(ConfirmationComponent, { centered: true, backdrop: 'static' });
		(modalRef.componentInstance as ConfirmationComponent).config = {
			title: this.labels().INVALID_PLAN_MODAL_TITLE,
			message,
			confirmBtn: this.labels().INVALID_PLAN_MODAL_CONFIRM_BTN,
			isCancelBtn: false
		};
		modalRef.result.then(() => globalThis.location.href = this.config.patplanSite);
	}

}
